import React, { ReactNode, useContext } from "react";
import dynamic from "next/dynamic";
import Context from "@components/useContext/context";
import removeModalBackgroundScroll from "@utils/removeModalBackgroundScroll";
import { modalCrossClicked } from "segments/eventActions/renewals/callBackModule";
import { useDispatch } from "react-redux";
import { nudgeCloseClicked } from "@renewals/store/analyticsData/eventActions/checkout";

const ModalMobile = dynamic<any>(
  () => import("@acko-tech/building-blocks.ui.modal").then(c => c.ModalMobile),
  {
    ssr: true
  }
);

const ModalDesktop = dynamic<any>(
  () => import("@acko-tech/building-blocks.ui.modal").then(c => c.ModalDesktop),
  {
    ssr: true
  }
);

interface Props {
  modalHeading?: string | ReactNode;
  showModal: boolean;
  setShowModal: Function;
  hideCloseButton?: boolean;
  children: any;
  styles?: any;
  onClose?: any;
  disableOverlayClose?: any;
  modalName?: any;
  bodyMargin?: string;
  wrapperStyles?: any;
  closeButtonStyles?: any;
  modalHeadingStyles?: any;
  cueText?: string;
}

const Modal = ({
  modalHeading,
  showModal,
  setShowModal,
  children,
  hideCloseButton,
  styles,
  onClose,
  // this prop prevents closing of modal when clicked on modal background (overlay)
  disableOverlayClose, // default value : false (which closes modal when clicked on overlay)
  modalName,
  bodyMargin,
  wrapperStyles,
  closeButtonStyles,
  modalHeadingStyles,
  cueText
}: Props) => {
  const { isDesktop } = useContext(Context);
  const dispatch = useDispatch();
  removeModalBackgroundScroll({ showModal });

  const Modal = isDesktop ? ModalDesktop : ModalMobile;
  return (
    <Modal
      maxWidth="600px"
      maxHeight="95vh"
      styles={{ ...styles, overflow: "auto !important" }}
      show={showModal}
      disableOverlayClose={disableOverlayClose}
      onHide={() => {
        onClose && onClose();
        setShowModal(false);
        dispatch(modalCrossClicked({ modal_name: modalName }));
        dispatch(nudgeCloseClicked({ edata: { modal_name: modalName } }));
      }}
      urlhash=""
      showOverlayBackground
      wrapperStyles={{
        padding: "32px 20px 20px",
        maxHeight: "95vh",
        ...wrapperStyles
      }} // used by mobile modal container
      padding={isDesktop ? "32px" : "24px 20px 20px"}
      bodyMargin={bodyMargin ? bodyMargin : ""}
      header={
        <>
          {modalHeading && (
            <div
              style={{
                fontSize: "18px",
                fontWeight: 600,
                lineHeight: "1.5rem",
                textAlign: isDesktop ? "center" : "left",
                maxWidth: "90%",
                width: isDesktop ? "100%" : "auto",
                color: "#040222",
                ...modalHeadingStyles
              }}
            >
              {modalHeading}
              {cueText && (
                <div
                  style={{
                    color: "#5B5675",
                    fontSize: "14px",
                    fontWeight: "400",
                    lineHeight: "20px",
                    opacity: "0.8",
                    marginTop: "8px"
                  }}
                >
                  {cueText}
                </div>
              )}
            </div>
          )}
        </>
      }
      hideCloseButton={hideCloseButton}
      hideTopPadding={hideCloseButton}
      closeButtonStyles={{
        top: "0px",
        // right: isDesktop ? "-36px" : "",
        ...closeButtonStyles
      }}
    >
      {children}
    </Modal>
  );
};

export default Modal;
